import SectionHeading from "@/pages/home/components/SectionHeading";
import { trendingBoard, trendingTags } from "@/mocks/trending";

const trendIcon: Record<string, { icon: string; color: string }> = {
  up: { icon: "ri-arrow-up-line", color: "text-accent-600" },
  down: { icon: "ri-arrow-down-line", color: "text-secondary-600" },
  flat: { icon: "ri-subtract-line", color: "text-foreground-400" },
};

export default function Trending() {
  return (
    <section id="trending" className="w-full bg-background-100 px-4 md:px-8 py-16 md:py-24">
      <div className="max-w-shell mx-auto">
        <SectionHeading
          index="06"
          eyebrow="热议榜"
          title="大家正在围观与拆解的热点"
          desc="按讨论热度与信息完整度排序，热度高的不一定最重要，但一定最值得先看懂。"
        />

        <div className="mt-10 md:mt-14 grid grid-cols-1 lg:grid-cols-12 gap-8">
          <div className="lg:col-span-8">
            <ol className="rounded-lg border border-background-200/80 bg-background-50 overflow-hidden">
              {trendingBoard.map((item, idx) => {
                const t = trendIcon[item.trend] ?? trendIcon.flat;
                return (
                  <li
                    key={item.rank}
                    className={`group flex items-center gap-4 px-4 md:px-6 py-4 transition-colors hover:bg-background-100/70 cursor-pointer ${
                      idx !== trendingBoard.length - 1 ? "border-b border-background-200/70" : ""
                    }`}
                  >
                    <span
                      className={`font-heading text-lg md:text-xl font-bold w-7 shrink-0 ${
                        item.rank <= 3 ? "text-primary-500" : "text-background-400"
                      }`}
                    >
                      {item.rank.toString().padStart(2, "0")}
                    </span>
                    <div className="min-w-0 flex-1">
                      <div className="flex flex-wrap items-center gap-2">
                        <h3 className="font-heading text-sm md:text-base font-bold text-foreground-950 group-hover:text-primary-700 transition-colors">
                          {item.title}
                        </h3>
                        <span className="rounded-full bg-secondary-100 text-secondary-900 px-2 py-0.5 text-[10px]">
                          {item.tag}
                        </span>
                      </div>
                      <div className="mt-1 text-[11px] md:text-xs text-foreground-400">
                        {item.stat}
                      </div>
                    </div>
                    <div className="hidden sm:flex flex-col items-end shrink-0">
                      <span className="flex items-center gap-1 text-sm text-foreground-800">
                        <i className="ri-fire-line text-accent-500" />
                        {item.heat}
                      </span>
                      <span className={`flex items-center gap-0.5 text-[11px] ${t.color}`}>
                        <i className={t.icon} />
                        {item.trend === "up" ? "上升" : item.trend === "down" ? "回落" : "持平"}
                      </span>
                    </div>
                  </li>
                );
              })}
            </ol>
          </div>

          <aside className="lg:col-span-4 space-y-6">
            <div className="rounded-lg border border-background-200/80 bg-background-50 p-5 md:p-6">
              <div className="flex items-center gap-2 text-xs tracking-[0.2em] text-primary-600">
                <i className="ri-hashtag" />
                热门标签
              </div>
              <div className="mt-4 flex flex-wrap gap-2">
                {trendingTags.map((tag) => (
                  <a
                    key={tag}
                    href="#trending"
                    className="rounded-full border border-background-200 bg-background-100/60 px-3 py-1.5 text-xs text-foreground-700 hover:border-primary-300 hover:text-primary-700 transition-colors cursor-pointer"
                  >
                    #{tag}
                  </a>
                ))}
              </div>
            </div>

            <div className="rounded-lg border border-background-200/80 bg-background-50 p-5 md:p-6">
              <div className="flex items-center gap-2 text-xs tracking-[0.2em] text-secondary-700">
                <i className="ri-line-chart-line" />
                榜单说明
              </div>
              <ul className="mt-4 space-y-3 text-sm text-foreground-600 leading-relaxed">
                <li className="flex gap-2.5">
                  <span className="font-heading text-primary-500 font-bold">01</span>
                  热度取自公开讨论量与阅读完成率
                </li>
                <li className="flex gap-2.5">
                  <span className="font-heading text-primary-500 font-bold">02</span>
                  信息完整度越高，排序越靠前
                </li>
                <li className="flex gap-2.5">
                  <span className="font-heading text-primary-500 font-bold">03</span>
                  每 2 小时随讨论变化自动刷新
                </li>
              </ul>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}